export enum FeedbackType {
  PROSPECT_APPOINTMENT = 'PROSPECT_APPOINTMENT',
}
